import { MouseEvent } from "react";
import { Article, ArticleHit } from "../article";
import PlaceholderImage from "@/frontend/algolia/components/PlaceholderImage";
import { cn } from "../../utils/cn";
import appendHeightParam from "@/frontend/algolia/utils/appendHeightParam";

export function ArticleCard({ articleHit, onSelect, layout }: { articleHit: ArticleHit; onSelect?: (hit: ArticleHit) => void; layout: "vertical" | "horizontal"; }) {
  function clickHandler<T extends HTMLElement = HTMLAnchorElement>(event: MouseEvent<T>) {
    event.preventDefault()
    onSelect && onSelect(articleHit)
  }

  const article: Article = articleHit;
  const imageContainerStyles = "tw-aspect-[4/3] tw-w-full tw-overflow-hidden tw-relative";
  const imageStyles = "tw-h-full tw-w-full tw-object-cover tw-transition-transform tw-duration-200 tw-ease-out";
  const placeHolderImageStyles = cn(
    "tw-aspect-[4/3] tw-bg-search-grey/10 tw-w-full tw-h-full tw-flex tw-justify-center tw-items-center",
    "[&>img]:tw-p-10 [&>img]:tw-object-contain [&>img]:tw-object-center",
  );

  const commonCardStyles = "tw-pt-30 xl:tw-pt-0 xl:tw-px-0 tw-flex tw-flex-col-reverse tw-justify-end tw-gap-x-10 tw-overflow-hidden [&>span]:tw-pt-2 md:[&>span]:tw-p-2 [&>span]:tw-space-y-4 [&>span]:tw-pb-20 md:[&>span]:tw-pb-b";

  const layoutClasses = layout === "horizontal" ? "tw-bg-search-grey/10 md:tw-grid tw-grid-cols-2 md:tw-h-[250px]" : "";
  
  const cardClass = cn(commonCardStyles, layoutClasses);

  return (
    <a href={`/blogs/${article.blog.handle}/${article.handle}`} onClick={clickHandler} className={cardClass}>
      <span>
        <h3 className="tw-text-[22px] tw-font-medium tw-capitalize tw-line-clamp-3">{article.title}</h3>

        <div className="tw-text-search-grey tw-line-clamp-3" dangerouslySetInnerHTML={{ __html: article.body_html }}></div>
      </span>

      {article.image ? (
        <div className={imageContainerStyles}>
          <img src={appendHeightParam(article.image, 500)} alt="" className={imageStyles} onClick={clickHandler<HTMLImageElement>} />
        </div>
      ) : <div className={placeHolderImageStyles}><PlaceholderImage /></div>}
    </a>
  );
};